module.exports = __webpack_public_path__ + "media/images/views/lp/about-us/goal-e9334ca7cbc09325672a994ed0e18681.png";